export default [
	{
		metric: {
			label: 'kg/ha',
			factor: 1
		},
		us: {
			label: 'lb/ac',
			factor: 0.892179
		},
		key: 'kg/ha'
	},
	{
		metric: {
			label: 't/m3',
			factor: 1
		},
		us: {
			label: 't/ft3',
			factor: 0.0283168
		},
		key: 't/m3'
	},
	{
		metric: {
			label: 'L/m3',
			factor: 1
		},
		us: {
			label: 'gal/ft3',
			factor: 0.00748052
		},
		key: 'L/m3'
	},
	{
		metric: {
			label: 'g/cm3',
			factor: 1
		},
		us: {
			label: 'oz/inch3',
			factor: 0.578037
		},
		key: 'g/cm3'
	},
	{
		metric: {
			label: 'g/L',
			factor: 1
		},
		us: {
			label: 'oz/gal',
			factor: 0.133526
		},
		key: 'g/L'
	},
	{
		metric: {
			label: 'dS/m',
			factor: 1
		},
		us: {
			label: 'dS/m',
			factor: 1
		},
		key: 'dS/m'
	},
	{
		metric: {
			label: 'm3',
			factor: 1
		},
		us: {
			label: 'ft3',
			factor: 35.3147
		},
		key: 'm3'
	},
	{
		metric: {
			label: 'g/m3',
			factor: 1
		},
		us: {
			label: 'lb/gal',
			factor: 8.3454
		},
		key: 'g/m3'
	},
	{
		metric: {
			label: 'ha',
			factor: 1
		},
		us: {
			label: 'ac',
			factor: 2.47105
		},
		key: 'ha'
	},
	{
		metric: {
			label: 't/ha',
			factor: 1
		},
		us: {
			label: 't/ac',
			factor: 0.44608956081
		},
		key: 't/ha'
	},
	{
		metric: {
			label: 'm/s',
			factor: 1
		},
		us: {
			label: 'ft/s',
			factor: 3.28083989
		},
		key: 'm/s'
	},
	{
		metric: {
			label: 'kg/L',
			factor: 1
		},
		us: {
			label: 'lb/gal',
			factor: 8.3454
		},
		key: 'kg/L'
	},
	{
		metric: {
			label: 'kg',
			factor: 1
		},
		us: {
			label: 'lb',
			factor: 2.20462
		},
		key: 'kg'
	},
	{
		metric: {
			label: 'T',
			factor: 1
		},
		us: {
			label: 'lb',
			factor: 2000
		},
		key: 'T'
	},
	{
		metric: {
			label: 'g',
			factor: 1
		},
		us: {
			label: 'lb',
			factor: 0.00220462
		},
		key: 'g'
	},
	{
		metric: {
			label: 'g',
			factor: 1
		},
		us: {
			label: 'oz',
			factor: 0.035274
		},
		key: 'g'
	},
	{
		metric: {
			label: 'L',
			factor: 1
		},
		us: {
			label: 'gal',
			factor: 0.264172
		},
		key: 'L'
	},
	{
		metric: {
			label: 'mL',
			factor: 1
		},
		us: {
			label: 'fl.oz',
			factor: 0.033814
		},
		key: 'mL'
	},
	{
		metric: {
			label: 'kM',
			factor: 1
		},
		us: {
			label: 'm',
			factor: 1000
		},
		key: 'kM'
	},
	{
		metric: {
			label: 'm',
			factor: 1
		},
		us: {
			label: 'yd',
			factor: 1.09361
		},
		key: 'm'
	},
	{
		metric: {
			label: 'cm',
			factor: 1
		},
		us: {
			label: 'ft',
			factor: 0.0328084
		},
		key: 'cm'
	},
	{
		metric: {
			label: 'cm',
			factor: 1
		},
		us: {
			label: 'in',
			factor: 0.393701
		},
		key: 'cm_inch'
	},
	{
		metric: {
			label: '°C',
		},
		us: {
			label: '°F',
		},
		key: 'C'
	},
];
